import script from "./TimeSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimeSelect.vue?vue&type=script&setup=true&lang=ts"

import "./TimeSelect.vue?vue&type=style&index=0&id=3c8c555b&lang=scss"

const __exports__ = script;

export default __exports__